import React, { useContext, useEffect, useState } from 'react';
import OrgLoginPage from '../pages/orgLoginPage/OrgLoginPage';
import { Navigate, Route, Routes } from 'react-router-dom';
import OrgRegister from '../pages/orgRegister/OrgRegister';
import Footer from '../webPageSections/footer/Footer';
import { OrgAuthContext } from '../context/OrgAuthContext';
import { toast } from 'react-toastify';
import OrgGuidLeftMenu from '../components/Guid/orgGuidLeftMenu/OrgGuidLeftMenu';
import GuidDashboard from '../components/Guid/guidDashboard/GuidDashboard';
import OrgGuidPackList from '../components/Guid/orgGuidPackList/OrgGuidPackList';
import OrgGuidBillings from '../components/Guid/orgGuidBillings/OrgGuidBillings';
import OrgGuidBookings from '../components/Guid/orgGuidBookings/OrgGuidBookings';
import OrgGuidReviews from '../components/Guid/orgGuidReviews/OrgGuidReviews';
import OrgGuidInsights from '../components/Guid/orgGuidInsights/OrgGuidInsights';
import OrgGuidAnalytics from '../components/Guid/orgGuidAnalytics/OrgGuidAnalytics';
import OrgHeader from '../webPageSections/orgPageSection/orgHeader/OrgHeader';
import OrgGuidPackupload from '../pages/organizer/orgGuidPackUpload/OrgGuidPackupload';
import OrgGuidDetails from '../pages/organizer/orgGuidDetails/OrgGuidDetails';
import OrgAccount from '../pages/orgAccount/OrgAccount';
import OrgGuDateDetails from '../components/Guid/orgGuDateDetails/OrgGuDateDetails';
import AddBooking from '../pages/orgTripDateDeails/addBooking/AddBooking';
import AddBookingOthers from '../components/addBookingOthers/AddBookingOthers';
import { OrgDatesProvider } from '../context/OrgDatesContest';

const orgClearItems = ['orgName', 'orgId', 'orgToken', 'orgExpiry', 'type', 'org'];
const headerButtons = {
    roleText: ['Add Booking', 'Create Guide'],
    rolelink: ['/org/g/create/pack', '/org/g/create/pack']
};
const OrgGuidLayout = () => {
    const { isOrgAuthenticated } = useContext(OrgAuthContext);
    const [addBo, setAddBo] = useState(false);
    const isLoginExpiredOrg = () => {
        const expiryTime = Number(window.localStorage.getItem('orgExpiry'));
        return expiryTime && Date.now() > expiryTime;
    };

    const monitorLoginExpiryOrg = () => {
        const interval = setInterval(() => {
            if (window.location.pathname !== '/org/login') {
                if (isLoginExpiredOrg()) {
                    toast.error('Session has expired. Login again to continue');
                    setTimeout(() => {
                        orgClearItems.forEach((key) => {
                            localStorage.removeItem(key); // Removes the specified key
                        }); // Clear all local storage
                        clearInterval(interval); // Stop further checks
                        window.location = '/org/login';
                    }, 3000);
                }
            }
        }, 10000); // Check every 10 seconds
    };

    useEffect(() => {
        //The below if consition shouln't be used as it will make the duntion
        //not get triggred in other pages also
        monitorLoginExpiryOrg();
        //eslint-disable-next-line
    }, []);
    return (
        <>
            {isOrgAuthenticated ? (
                <>
                    <OrgHeader
                        roleText={headerButtons.roleText}
                        rolelink={headerButtons.rolelink}
                        setAddBo={setAddBo}
                    />
                    <div className='org-main-container'>
                        <OrgGuidLeftMenu />
                        <main className='org-content'>
                            <Routes>
                                <Route path='/register' element={<OrgRegister />} />
                                <Route path='/*' element={<Navigate to='dashboard' />} />
                                <Route path='/dashboard' element={<GuidDashboard />} />
                                <Route path='/my-guide' element={<OrgGuidPackList />} />
                                <Route path='/billing' element={<OrgGuidBillings />} />
                                <Route path='/payouts' element={<OrgGuidBillings />} />
                                <Route path='/bookings' element={<OrgGuidBookings />} />
                                <Route path='/reviews' element={<OrgGuidReviews />} />
                                <Route path='/date/:guDateId/:slotId' element={<OrgGuDateDetails />} />
                                <Route path='/account' element={<OrgAccount />} />
                                <Route path='/create/pack' element={<OrgGuidPackupload />} />
                                <Route
                                    path='/details/:guideId'
                                    element={
                                        <OrgDatesProvider>
                                            <OrgGuidDetails />
                                        </OrgDatesProvider>
                                    }
                                />
                                <Route path='/insights' element={<OrgGuidInsights />} />
                                <Route path='/analytics' element={<OrgGuidAnalytics />} />
                            </Routes>
                        </main>
                        <Footer />
                    </div>
                    {addBo && <AddBookingOthers setAddBo={setAddBo} />}
                </>
            ) : (
                <Routes>
                    <Route path='/login' element={<OrgLoginPage />} />
                    <Route path='/*' element={<Navigate to='login' />} />
                    <Route path='/register' element={<OrgRegister />} />
                </Routes>
            )}
        </>
    );
};

export default OrgGuidLayout;
